// src/config/navigation.js
import { USER_TYPES } from "./roles";

// Each item: { label, to, icon, perm, disabledIf? }
export const NAV_CONFIG = {
  [USER_TYPES.ADMIN]: [
    { label: "Dashboard", to: "/admin", perm: "admin.dashboard" },
    { label: "User Management", to: "/admin/users", perm: "admin.users" },
    { label: "Project Management", to: "/admin/projects", perm: "admin.projects" },
    { label: "Furniture", to: "/admin/furnitures", perm: "admin.furnitures" },
    { label: "3D Assemblies", to: "/admin/assets", perm: "admin.assets" },
    { label: "Quotes", to: "/admin/quotes", perm: "admin.quotes" },
    { label: "Purchase Plan", to: "/admin/purchase-plans", perm: "admin.purchaseplans" },
    { label: "Subscriptions", to: "/admin/subscriptions", perm: "admin.subscriptions" },
    { label: "Reports", to: "/admin/reports", perm: "admin.reports" },
    { label: "Security", to: "/admin/security", perm: "admin.security" },
    { label: "Revit",    to: "/admin/revit",    perm: "admin.revit"    },
  ],
  [USER_TYPES.CEED]: [
    { label: "Dashboard",      to: "/ceed",                    perm: "ceed.dashboard" },
    { label: "Projects",       to: "/ceed/projects",           perm: "ceed.projects" },
    { label: "Furniture",      to: "/ceed/furnitures",         perm: "ceed.furnitures" },
    { label: "3D Assemblies",  to: "/ceed/assets",             perm: "ceed.assets" },
    { label: "Purchase Plans", to: "/ceed/purchase-plans",     perm: "ceed.purchaseplans" },
    { label: "Quotes",         to: "/ceed/quotes",             perm: "ceed.quotes" },
    { label: "Reports",        to: "/ceed/reports",            perm: "ceed.reports" },
    { label: "Notifications",  to: "/ceed/notifications",      perm: "ceed.notifications" },
  ],
  [USER_TYPES.INDIVIDUAL]: [
    { label: "Dashboard", to: "/dashboard", perm: "app.dashboard" },
    { label: "Projects", to: "/dashboard/projects", perm: "app.projects" },
    { label: "Engineering Plans", to: "/dashboard/engineering-plans", perm: "app.engineeringplans" },
    { label: "Quotes", to: "/dashboard/quotes", perm: "app.quotes" },
    { label: "Auto Estimator", to: "/dashboard/estimator", perm: "app.estimator" },
    { label: "Subscription", to: "/dashboard/subscription", perm: "app.subscription" },
    { label: "Support/Help", to: "/dashboard/support", perm: "app.support" },
  ],

  [USER_TYPES.OWNER]: [
    { label: "Dashboard", to: "/dashboard", perm: "app.dashboard" },
    { label: "Projects", to: "/dashboard/projects", perm: "app.projects" },
    { label: "Engineering Plans", to: "/dashboard/engineering-plans", perm: "app.engineeringplans" },
    { label: "Staff", to: "/dashboard/staff", perm: "app.staff" },
    { label: "Quotes", to: "/dashboard/quotes-org", perm: "app.orgquotes" },
    { label: "Auto Estimator", to: "/dashboard/autoestimator", perm: "app.autoestimator" },
    { label: "Custom Branding", to: "/dashboard/branding", perm: "app.branding.edit" },
    { label: "Subscription", to: "/dashboard/subscription", perm: "app.subscription" },
    { label: "Support/Help", to: "/dashboard/support", perm: "app.support" },
  ],
  
  [USER_TYPES.STAFF]: [
    { label: "Dashboard", to: "/dashboard", perm: "app.dashboard" },
    { label: "Projects", to: "/dashboard/projects", perm: "app.projects" },
    { label: "Engineering Plans", to: "/dashboard/engineering-plans", perm: "app.engineeringplans" },
    { label: "Auto Estimator", to: "/dashboard/autoestimator", perm: "app.autoestimator" },
    { label: "Quotes", to: "/dashboard/quotes-org", perm: "app.orgquotes" },
    { label: "Custom Branding", to: "/dashboard/branding", perm: "app.branding.edit" },
    { label: "Subscription", to: "/dashboard/subscription", perm: "app.subscription" },
    { label: "Support/Help", to: "/dashboard/support", perm: "app.support" },
  ],
  
  [USER_TYPES.INVITED]: [
    { label: "Dashboard", to: "/dashboard", perm: "app.dashboard" },
    { label: "Projects", to: "/dashboard/projects", perm: "app.projects" },
    { label: "Engineering Plans", to: "/dashboard/engineering-plans", perm: "app.engineeringplans" },
    { label: "Quotes", to: "/dashboard/myquotes", perm: "app.myquotes" },
    { label: "Support/Help", to: "/dashboard/support", perm: "app.support" },
  ],
};
